<template>
  <div class="groups-container">
    <b-list-group class="list-unstyled">
      <b-row align-v="start">
        <b-col lg="3" md="6" sm="12" xs="12" class="member-column mb-3" v-for="group in groups" :key="group.id">
          <MembersMedia v-bind:group="group"></MembersMedia>
        </b-col>
      </b-row>
    </b-list-group>
  </div>
</template>

<script>
import MembersMedia from './MembersMedia'
export default {
  name: 'groups',
  props: {
    'groups': Array
  },
  components: {
    MembersMedia
  }
}
</script>

<style>
  .group-container {
    border: 1px solid #eeeff0;
    min-width: 240px
  }
  .member-column {
    display: flex;
    justify-content: space-between;
    width: 260px;
  }
</style>



// WEBPACK FOOTER //
// src/components/groups/MembersList.vue